module.exports = __webpack_public_path__ + "img/payment_methods.c4765cd7.png";